import {useCallback, useEffect} from "react"
import {DimensionamentoService} from "../services/DimensionamentoServices"
import {mapRegionDicts} from "./mapRegionDicts"

export function useMapUfs(
  selectedRegion,
  selectedState,
  regionInputDataSetter,
  beneficiariosDemo,
  allMapCities,
  macro,
  micro,
  setMacro,
  setMicro,
  sortOption
) {
  const allRegionFromStates = mapRegionDicts[selectedState.toLowerCase()]


  useEffect(() => {
    const regionMap = {
      "Micro-Região": "MUNICÍPIO SEDE MICRORREGIÃO",
      "Macro-Região": "MUNICÍPIO SEDE MACRORREGIÃO",
      "Cidade": "NOME DO MUNICÍPIO"
    }

    const regionType = regionMap[selectedRegion]
    if (!regionType) return

    const shouldLoadMacro = selectedRegion === "Macro-Região"
    const shouldLoadMicro = selectedRegion === "Micro-Região"

    if (shouldLoadMacro || shouldLoadMicro) {
      const fetch = allRegionFromStates
        ? DimensionamentoService.getRegions(regionType, allRegionFromStates)
        : DimensionamentoService.getRegions(regionType, selectedState)

      fetch.then((initialResults) => {
        if (selectedRegion === "Macro-Região") {
          setMacro(initialResults)
        } else if (selectedRegion === "Micro-Região") {
          setMicro(initialResults)
        }
      }).catch((error) => {
        console.error("Erro ao carregar regiões:", error);
      });
    }
  }, [
    selectedRegion,
    selectedState,
    macro.length,
    micro.length,
    allRegionFromStates,
    setMacro,
    setMicro,
    sortOption
  ]);

  return useCallback(() => {
    switch (selectedRegion) {
      case "Município":
        regionInputDataSetter(
          allMapCities.map((city) => {
            const found = beneficiariosDemo.valuesCity.find(
              (item) => sortOption === 'default' ?  item[0].split(" - ")[0] === city : item[0] === city
            )
            return found || [city, ...Array(1).fill(0)]
          })
        )
        break

      case "Micro-Região":
        regionInputDataSetter(
          micro.map((region) => {
            const found = beneficiariosDemo.valuesMicro.find(
              (item) => item[0] === region
            )
            return found || [region, ...Array(1).fill(0)]
          })
        )
        break

      case "Macro-Região":
        regionInputDataSetter(
          macro.map((region) => {
            const found = beneficiariosDemo.valuesMacro.find(
              (item) => item[0] === region
            )
            return found || [region, ...Array(1).fill(0)]
          })
        );
        break

      default:
        return
    }
  }, [
    selectedRegion,
    regionInputDataSetter,
    allMapCities,
    micro,
    macro,
    beneficiariosDemo,
    sortOption
  ]);
}
